import * as amplitude from "@amplitude/analytics-browser";
import { api_config } from "./env";

const ANONYMOUS_ID = "sentinex-anon";

export function initAnalytics(): void {
  const apiKey: string = api_config.amplitude_api_key;
  if (!apiKey) {
    return;
  }

  const environment: string = api_config.analytics_environment || "unknown";

  amplitude.init(apiKey, ANONYMOUS_ID, {
    deviceId: ANONYMOUS_ID,
    serverUrl: api_config.amplitude_server_url || undefined,
    identityStorage: "none",
    autocapture: {
      pageViews: true,
      sessions: false,
      attribution: false,
    },
    remoteConfig: { fetchRemoteConfig: false },
    trackingOptions: { ipAddress: false, language: false, platform: false },
    flushMaxRetries: 1,
  });

  amplitude.add({
    name: "environment",
    type: "enrichment",
    execute: async (event) => ({
      ...event,
      event_properties: { ...event.event_properties, environment },
    }),
  });
}
